/**
 * Parts of the app that are built but not yet open to people.
 *
 * Switched off here, in one place, rather than deleted: the code and its data
 * stay, and turning a part on is a one-line change and a release.
 */

/**
 * The "My record" tab of Events & Activities -- what somebody took part in:
 * events, courses, conferences -- and the links that lead to it.
 *
 * Off for the PhD programme's start (Nov 2026): the activities are tracked
 * from now, but there are no events yet and the event side needs more work.
 */
export const RECORD_ENABLED = false;
